module.exports = __webpack_public_path__ + "static/assets/ed7c5baad1bebf48c43b69ed3d3fe028.svg";